import { create } from 'zustand';
import { productsApi } from '../api/productsApi';
import type { BonusClaimResult } from '../types/domain';
import { IDLE_LOAD, LOADING_LOAD, READY_LOAD, failedLoad, type LoadState } from './loadState';

interface BonusClaimsState {
  claimedBonuses: string[];
  load: LoadState;

  loadClaims: () => Promise<void>;
  claimBonus: (bonusId: string) => Promise<BonusClaimResult>;
  reset: () => void;
}

export const useBonusClaimsStore = create<BonusClaimsState>((set, get) => ({
  claimedBonuses: [],
  load: IDLE_LOAD,

  async loadClaims() {
    set({ load: LOADING_LOAD });
    try {
      const claimedBonuses = await productsApi.getClaimedBonuses();
      set({ claimedBonuses, load: READY_LOAD });
    } catch (err) {
      set({ load: failedLoad(err) });
    }
  },

  async claimBonus(bonusId) {
    const result = await productsApi.claimBonus(bonusId);
    if (!get().claimedBonuses.includes(bonusId)) {
      set((s) => ({ claimedBonuses: [...s.claimedBonuses, bonusId] }));
    }
    return result;
  },

  reset() {
    set({ claimedBonuses: [], load: IDLE_LOAD });
  },
}));
